import WidgetList from '../container/list/WidgetList';

function WidgetListPage() {
    return <WidgetList />;
}

export default WidgetListPage;
